import { RepositoryFactory } from '@/repositories/PassageApi/RepositoryFactory.js'
const ExecutionRepository = RepositoryFactory.get('execution')

class ExecutionService {
  static async getExecutions (eventId) {
    try {
      return await ExecutionRepository.getExecutions(eventId)
    } catch (error) {
      console.log(error)
    }
  }

  static async createExecution (eventId, data) {
    try {
      return await ExecutionRepository.createExecution(eventId, data)
    } catch (error) {
      console.log(error)
    }
  }

  static async updateExecution (eventId, executionId, data) {
    try {
      return await ExecutionRepository.updateExecution(eventId, executionId, data)
    } catch (error) {
      console.log(error)
    }
  }

  static async finishJudgeExecution (executionId, judgeId, data) {
    try {
      return await ExecutionRepository.finishJudgeExecution(executionId, judgeId, data)
    } catch (error) {
      console.log(error)
    }
  }

  static async updateJudgeExecution (executionId, judgeExecutionId, data) {
    try {
      return await ExecutionRepository.updateJudgeExecution(executionId, judgeExecutionId, data)
    } catch (error) {
      console.log(error)
    }
  }

  static async deleteExecution (eventId, executionId) {
    try {
      return await ExecutionRepository.deleteExecution(eventId, executionId)
    } catch (error) {
      console.log(error)
    }
  }

  static async deleteExecutionData (eventId, executionId) {
    try {
      return await ExecutionRepository.deleteExecutionData(eventId, executionId)
    } catch (error) {
      console.log(error)
    }
  }
  
  static async deleteJudgeExecution (executionId, judgeExecutionId) {
    try {
      return await ExecutionRepository.deleteJudgeExecution(executionId, judgeExecutionId)
    } catch (error) {
      console.log(error)
    }
  }

  static async createJudgeExecutionList (executionId, data) {
    try {
      return await ExecutionRepository.createJudgeExecutionList(executionId, data)
    } catch (error) {
      console.log(error)
    }
  }

  static async getJudgesResultsExecutions (executionId, params) {
    try {
      return await ExecutionRepository.getJudgesResultsExecutions(executionId, params)
    } catch (error) {
      console.log(error)
    }
  }

  static async getJudgesResultsExercises (executionId, params) {
    try {
      return await ExecutionRepository.getJudgesResultsExercises(executionId, params)
    } catch (error) {
      console.log(error)
    }
  }

  static async saveJudgesResultsExercises (executionId, data) {
    try {
      return await ExecutionRepository.saveJudgesResultsExercises(executionId, data)
    } catch (error) {
      console.log(error)
    }
  }

  static async updateJudgesResultsExercisesList (executionId, judgeId, data) {
    try {
      return await ExecutionRepository.updateJudgesResultsExercisesList(executionId, judgeId, data)
    } catch (error) {
      console.log(error)
    }
  }

  static async updateJudgeResultExecution (executionId, resultExecutionId, data) {
    try {
      return await ExecutionRepository.updateJudgeResultExecution(executionId, resultExecutionId, data)
    } catch (error) {
      console.log(error)
    }
  }

  static async getResultSummary (executionId, params) {
    try {
      return await ExecutionRepository.getResultSummary(executionId, params)
    } catch (error) {
      console.log(error)
    }
  }

  static async getJudgesInresults (executionId, params) {
    try {
      return await ExecutionRepository.getJudgesInresults(executionId, params)
    } catch (error) {
      console.log(error)
    }
  }

  static async getExecution (eventId, executionId) {
    try {
      return await ExecutionRepository.getExecution(eventId, executionId)
    } catch (error) {
      console.log(error)
    }
  }

  static async downloadBinomios (eventId) {
    try {
      return await ExecutionRepository.downloadBinomios(eventId)
    } catch (error) {
      console.log(error)
    }
  }

  static async downloadExecutionResults (executionId) {
    try {
      return await ExecutionRepository.downloadExecutionResults(executionId)
    } catch (error) {
      console.log(error)
    }
  }
}

export default ExecutionService
